import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { GoArrowLeft } from "react-icons/go";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import {
  listCategoryDropdown,
  listSubCategoryDropdown,
} from "../../../api/actions/category";
import { listMaterialDropdown } from "../../../api/actions/material";
import { DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";
import { listUserDropdown } from "../../../api/actions/user";
import { listRoomDropdown } from "../../../api/actions/room";
import start from "../../../assets/images/category/star.png";
import { subcategoryLoadOptionHandler } from "./loadOptionHandlers";

const GlobalsearchContent = ({
  setUpdate,
  update,
  setShowFilterBox,
  formik,
  setSelectedContents,
  contentHeader,
  onBackToFilter,
  showFilterBoxContent,
  selectedContents,
  isClearAll = false,
  setIsClearAll,
  isOpen,
}) => {
  const [category, setCatgory] = useState();
  const [categorLoading, setCategoryLoading] = useState(false);
  const [defaultcategory, setDefaultCategory] = useState([]);
  const [defaultSubcategory, setdefaulSubtCateory] = useState([]);
  const [subCategory, setSubcategory] = useState([]);
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [filterValue, setFilterValue] = useState([]);
  const [originalFilter, setOriginalFilter] = useState(null);
  const [transitFilter, setTransitFilter] = useState(null);
  const [material, setMaterial] = useState();
  const [minHeight, setMinHeight] = useState("");
  const [user, setUser] = useState([]);
  const [defaultUser, setDefaultUser] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [defaultMaterial, setDefaultMaterial] = useState([]);
  const [materialLoading, setMaterialLoading] = useState(false);
  const [room, setRoom] = useState([]);
  const [transitRoom, setTransitRoom] = useState({
    data: [],
    default: [],
  });
  const [roomLoading, setRoomLoading] = useState(false);
  const [initialFormikSnapshot, setInitialFormikSnapshot] = useState(null);
  const [menuIsOpen, setMenuIsOpen] = useState({
    subCategory: false,
    category: true,
    material: true,
    user: true,
    room: true,
    acquistion: true,
  });
  const [defaultRoom, setDefaultRoom] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const subCategoryRef = useRef(null);

  const { RangePicker } = DatePicker;

  const onIconicTrueHandler = (e, refrenceTitle) => {
    if (formik?.values?.hasIconic) {
      setFilterValue({
        title: contentHeader,
        value: "",
      });

      formik?.setValues({
        ...formik?.values,
        is_iconic: "",
        hasIconic: false,
        hasNoIconic: false,
      });
    } else {
      setFilterValue({
        title: contentHeader,
        value: "Iconic",
      });
      formik.setValues({
        ...formik?.values,
        is_iconic: true,
        hasIconic: true,
        hasNoIconic: false,
      });
    }
  };

  const onIconicFalseHandler = (e, refrenceTitle) => {
    if (formik?.values?.hasNoIconic) {
      setFilterValue({
        title: contentHeader,
        value: "",
      });

      formik?.setValues({
        ...formik?.values,
        is_iconic: "",
        hasIconic: false,
        hasNoIconic: false,
      });
    } else {
      setFilterValue({
        title: contentHeader,
        value: "Non iconic",
      });
      formik.setValues({
        ...formik?.values,
        is_iconic: false,
        hasIconic: false,
        hasNoIconic: true,
      });
    }
  };

  const onRemarkTrueHandler = (e, referenceTitle) => {
    if (formik?.values?.hasRemark) {
      // Unselect "Has remark"
      setFilterValue({
        title: contentHeader,
        value: "",
      });

      formik?.setValues({
        ...formik?.values,
        remarks: "",
        hasRemark: false,
        hasNoRemark: false,
      });
    } else {
      // Select "Has remark"
      setFilterValue({
        title: contentHeader,
        value: "Has remark",
      });

      formik?.setValues({
        ...formik?.values,
        remarks: true,
        hasRemark: true,
        hasNoRemark: false,
      });
    }
  };

  const onRemarkFalseHandler = (e, referenceTitle) => {
    if (formik?.values?.hasNoRemark) {
      // Unselect "No remark"
      setFilterValue({
        title: contentHeader,
        value: "",
      });

      formik?.setValues({
        ...formik?.values,
        remarks: "",
        hasRemark: false,
        hasNoRemark: false,
      });
    } else {
      // Select "No remark"
      setFilterValue({
        title: contentHeader,
        value: "No remark",
      });

      formik?.setValues({
        ...formik?.values,
        remarks: false,
        hasRemark: false,
        hasNoRemark: true,
      });
    }
  };

  const onRefernceTrueHandler = (e, refrenceTitle) => {
    if (formik?.values?.hasImage) {
      // If already checked, uncheck and reset
      setFilterValue({
        title: contentHeader,
        value: null,
      });
      formik.setValues({
        ...formik?.values,
        is_image: "",
        hasImage: false,
        hasNoImage: false,
      });
    } else {
      setFilterValue({
        title: contentHeader,
        value: "Reference image",
      });
      formik.setValues({
        ...formik?.values,
        is_image: true,
        hasImage: true,
        hasNoImage: false,
      });
    }
  };

  const onRefernceFalseHandler = (e, refrenceTitle) => {
    if (formik?.values?.hasNoImage) {
      // If already checked, uncheck and reset
      setFilterValue({
        title: contentHeader,
        value: null,
      });

      formik.setValues({
        ...formik?.values,
        is_image: "",
        hasImage: false,
        hasNoImage: false,
      });
    } else {
      setFilterValue({
        title: contentHeader,
        value: "No reference image",
      });
      formik.setValues({
        ...formik?.values,
        is_image: false,
        hasImage: false,
        hasNoImage: true,
      });
    }
  };

  const onDriveTrueHandler = (e, driveTitle) => {
    setFilterValue({
      title: contentHeader,
      value: "Drive url",
    });

    formik.setValues({
      ...formik?.values,
      is_drive_link: true,
      hasDrive: true,
      hasNoDrive: false,
    });
  };

  const onDriveFalseHandler = (e, driveTitle) => {
    setFilterValue({
      title: contentHeader,
      value: "No drive url",
    });

    formik.setValues({
      ...formik?.values,
      is_drive_link: false,
      hasDrive: false,
      hasNoDrive: true,
    });
  };

  const categoryChangeHandler = (categoryValue) => {
    if (!categoryValue?.length) {
      formik.setValues({
        ...formik?.values,
        primary_category: [],
        selectedCategory: [],
        category_id: [],
        selctedSubCategory: [],
      });
      setSubcategory();
      setdefaulSubtCateory([]);
    }
    setMenuIsOpen({
      category: false,
      subCategory: true,
    });

    setCatgory(defaultcategory);

    const selectedCategories = categoryValue || [];
    const categoryValues = selectedCategories.map((c) => c.value);

    const prevCategories = formik?.values?.primary_category || [];

    let filteredSubs = formik?.values?.selctedSubCategory || [];

    if (categoryValues.length === 0) {
      // 🔑 Case 1: cleared all primaries → clear all subs
      filteredSubs = [];
    } else {
      // 🔑 Case 2: remove subs only for primaries that were deselected
      const removedPrimaries = prevCategories.filter(
        (prev) => !categoryValues.includes(prev)
      );

      if (removedPrimaries.length) {
        filteredSubs = filteredSubs.filter(
          (sub) => !removedPrimaries.includes(sub.primary_category)
        );
      }
    }

    // Build display string
    const displayValue = selectedCategories
      .map((cat) => {
        const subsForCat = filteredSubs
          .filter((sub) => sub.primary_category === cat.value)
          .map((sub) => sub.label);

        return subsForCat.length
          ? `${cat.label} - ${subsForCat.join(", ")}`
          : cat.label;
      })
      .join(", ");

    setFilterValue({
      title: contentHeader,
      value: displayValue,
    });

    formik?.setValues({
      ...formik?.values,
      primary_category: categoryValues,
      selectedCategory: selectedCategories,
      category_id: filteredSubs.map((s) => s.value),
      selctedSubCategory: filteredSubs,
    });
  };

  const subCategoryChangeHandler = (subCategoryValue) => {
    setMenuIsOpen({ subCategory: false });
    if (subCategoryRef.current) subCategoryRef.current.blur();

    setSubcategory(defaultSubcategory);

    const selectedCategories = formik?.values?.selectedCategory || [];
    const prevSubs = formik?.values?.selctedSubCategory || [];

    // ✅ Always start with Formik's existing subs
    let mergedSubs = [...prevSubs];

    // ✅ Add new selections from component (avoiding duplicates)
    if (subCategoryValue && subCategoryValue.length > 0) {
      subCategoryValue.forEach((sub) => {
        if (!mergedSubs.some((s) => s.value === sub.value)) {
          mergedSubs.push(sub);
        }
      });
    }

    // ✅ Remove deselected items (keep only what is still in subCategoryValue)
    if (subCategoryValue) {
      const allowedIds = subCategoryValue.map((s) => s.value);
      mergedSubs = mergedSubs.filter((s) => allowedIds.includes(s.value));
    }

    // Build display string with both primary and subcategories
    const displayValue = selectedCategories
      .map((cat) => {
        const subsForCat = mergedSubs
          .filter((sub) => sub.primary_category === cat.value)
          .map((sub) => sub.label);

        return subsForCat.length
          ? `${cat.label} - ${subsForCat.join(", ")}`
          : cat.label;
      })
      .join(", ");

    setFilterValue({
      title: contentHeader,
      value: displayValue,
    });

    const subValues = mergedSubs.map((li) => li.value);

    formik?.setValues({
      ...formik?.values,
      category_id: subValues,
      selctedSubCategory: mergedSubs,
    });
  };

  const materialChangeHandler = (materialValue) => {
    setMaterial(defaultMaterial);
    const materialLabels = materialValue?.map((li) => li?.label);
    const materialValues = materialValue?.map((li) => li?.value);
    setFilterValue({
      title: contentHeader,
      value: materialLabels,
    });

    formik?.setValues({
      ...formik?.values,
      material_id: materialValues,
      selectedMaterial: materialValue,
    });
  };

  const handleMinChange = (e, type) => {
    const minKey = `${type}_min`;
    const maxKey = `${type}_max`;

    formik?.setValues({
      ...formik?.values,
      [minKey]: e === null ? formik?.values[maxKey] : e,
    });

    setFilterValue({
      title: contentHeader,
      value: `${e === null ? formik?.values[maxKey] : e} - ${
        formik?.values[maxKey]
      } (${type === "height" ? "cm" : "cm"})`,
    });
  };

  const handleMaxChange = (e, type) => {
    const minKey = `${type}_min`;
    const maxKey = `${type}_max`;

    formik?.setValues({
      ...formik?.values,
      [maxKey]: e === null ? formik?.values[minKey] : e,
    });

    setFilterValue({
      title: contentHeader,
      value: `${formik?.values[minKey]} - ${
        e === null ? formik?.values[minKey] : e
      } (${type === "height" ? "cm" : "cm"})`,
    });
  };

  const periodChangeHandler = (period) => {
    setFilterValue({
      title: contentHeader,
      value: `${period?.label} ${formik?.values?.period_start}-${formik?.values?.period_end}`,
    });

    formik?.setValues({
      ...formik?.values,
      period: period?.label,
      selectedPeriod: period,
    });
  };

  const periodStarthandler = (value) => {
    const inputValue = value?.target?.value;
    // Sanitize: Ensure it's a number and has 4 digits
    // const validValue = value && /^\d{4}$/.test(value.toString()) ? Number(value) : null;

    // const finalValue = validValue !== null ? validValue : formik?.values?.period_end;
    if (/^\d{0,4}$/.test(inputValue)) {
      setFilterValue({
        title: contentHeader,
        value: `${formik?.values?.period} ${inputValue}-${formik?.values?.period_end}`,
      });

      formik?.setValues({
        ...formik?.values,
        period_start: inputValue,
      });
    }
  };

  const periodEndthandler = (e) => {
    const inputValue = e?.target?.value;
    if (/^\d{0,4}$/.test(inputValue)) {
      setFilterValue({
        title: contentHeader,
        value: `${formik?.values?.period} ${formik?.values?.period_start}-${
          inputValue === null ? "" : inputValue
        }`,
      });

      formik?.setValues({
        ...formik?.values,
        period_end: inputValue === null ? "" : inputValue,
      });
    }
  };

  const accquistionChangeHandler = (acquisitionDataValue) => {
    // acquisitionDataValue is an array when isMulti
    const acquisitionLabels = acquisitionDataValue?.map((a) => a.label) || [];

    setFilterValue({
      title: contentHeader,
      value: acquisitionLabels.join(", "), // e.g., "Purchase, Donation"
    });

    formik?.setValues({
      ...formik?.values,
      acquisition_method: acquisitionLabels, // store as array
    });
  };

  const HandledateUpdatefilter = (value, dateString) => {
    const startDate = dateString[0];
    const endDate = dateString[1];

    setFilterValue({
      title: contentHeader,
      value: `${dayjs(startDate, "D-M-YYYY").format("DD-MMM-YYYY")} - ${dayjs(
        endDate,
        "D-M-YYYY"
      ).format("DD-MMM-YYYY")}`,
    });

    formik?.setValues({
      ...formik?.values,
      modified_start_date: startDate,
      modified_end_date: endDate,
      selectedUpdateDate: value,
    });
  };

  const Handledatefilter = (value, dateString) => {
    const startDate = dateString[0];
    const endDate = dateString[1];

    setFilterValue({
      title: contentHeader,
      value: `${dayjs(startDate, "D-M-YYYY").format("DD-MMM-YYYY")} - ${dayjs(
        endDate,
        "D-M-YYYY"
      ).format("DD-MMM-YYYY")}`,
    });

    formik?.setValues({
      ...formik?.values,
      start_date: startDate,
      end_date: endDate,
      selectedDate: value,
    });
  };

  const userChangeHandler = (userDataValue) => {
    // userDataValue is an array when isMulti
    const userValues = userDataValue?.map((u) => u.value) || [];
    const userLabels = userDataValue?.map((u) => u.label) || [];

    setFilterValue({
      title: contentHeader,
      value: userLabels.join(", "), // "Fernanda, Jhons"
    });

    formik?.setValues({
      ...formik?.values,
      created_by: userValues,
      selectedUser: userLabels, // store as array
    });
  };

  const roomChangeHandler = (roomDataValue) => {
    const roomValues = roomDataValue?.map((r) => r.value) || [];
    const roomLabels = roomDataValue?.map((r) => r.label) || [];

    setOriginalFilter({
      title: "Original location",
      value: roomLabels.join(", "),
    });

    formik.setValues({
      ...formik.values,
      room: roomValues,
      selectedRoom: roomLabels,
    });
  };

  const transiRoomChangeHandler = (transitRoomValue) => {
    const transitRoomValues = transitRoomValue?.map((r) => r.value) || [];

    const transitRoomLabels = transitRoomValue?.map((r) => r.label) || [];

    setTransitFilter({
      title: "Transit location",
      value: transitRoomLabels.join(", "),
    });

    formik.setValues({
      ...formik.values,
      transit_room: transitRoomValues,
      selectedTransitRoom: transitRoomLabels,
    });
  };

  const tagChangeHandler = (tagDataValue) => {
    const tagValue = tagDataValue?.target?.value;
    setFilterValue({
      title: contentHeader,
      value: tagValue,
    });

    formik?.setValues({
      ...formik?.values,
      tags: tagValue,
    });
  };

  // const onDriveTrueHandler = (e, driveTitle) => {
  //     setFilterValue({
  //         title: contentHeader,
  //         value: "Drive url"
  //     })
  //     formik.setValues({
  //         ...formik?.values,
  //         is_drive_link: true,
  //         hasDrive: true,
  //         hasNoDrive: false
  //     })

  // }

  // const onDriveFalseHandler = (e, driveTitle) => {
  //     setFilterValue({
  //         title: contentHeader,
  //         value: "No drive url"
  //     })
  //     formik.setValues({
  //         ...formik?.values,
  //         is_drive_link: false,
  //         hasDrive: false,
  //         hasNoDrive: true
  //     })

  // }

  const conditionGradeChangeHandler = (e, type) => {
    const checked = e.target.checked;

    let updatedGrades = [...(formik?.values?.conservation_grade || [])];
    let isEmergency = formik?.values?.is_emergency;

    if (type === "Emergency") {
      // ✅ Handle emergency separately
      isEmergency = checked;

      setFilterValue({
        title: contentHeader,
        value: [
          ...updatedGrades.map((g) =>
            g === "blank" ? "No condition grading" : g
          ),
          ...(checked ? ["Emergency"] : []),
        ]
          .filter(Boolean)
          .join(", "),
      });

      formik?.setValues({
        ...formik?.values,
        is_emergency: checked,
        conservation_grade: updatedGrades,
      });

      return;
    }

    // ✅ Handle normal grades (including "blank")
    if (checked) {
      if (!updatedGrades.includes(type)) {
        updatedGrades.push(type);
      }
    } else {
      updatedGrades = updatedGrades.filter((g) => g !== type);
    }

    // ✅ Prepare display text for filter
    const displayGrades = updatedGrades.map((g) =>
      g === "blank" ? "No condition grading" : g
    );

    setFilterValue({
      title: contentHeader,
      value: [...displayGrades, ...(isEmergency ? ["Emergency"] : [])].join(
        ", "
      ),
    });

    formik?.setValues({
      ...formik?.values,
      conservation_grade: updatedGrades,
      is_emergency: isEmergency,
    });
  };

  const photoStatusChangeHandler = (e, type) => {
    const conditionValue = e?.target?.checked;
    setFilterValue({
      title: contentHeader,
      value: type,
    });
    if (conditionValue) {
      if (type === "To do") {
        formik?.setValues({
          ...formik?.values,
          photography_status: "to_do",
        });
      } else if (type === "In photography") {
        formik?.setValues({
          ...formik?.values,
          photography_status: "in_photography",
        });
      } else if (type === "Photography complete") {
        formik?.setValues({
          ...formik?.values,
          photography_status: "photography_complete",
        });
      } else if (type === "Reshoot") {
        formik?.setValues({
          ...formik?.values,
          photography_status: "re_shoot",
        });
      }
    }
  };

  let typingTimeruser;
  const userLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimeruser);
      typingTimeruser = setTimeout(() => {
        if (inputValue.length >= 1) {
          listUserDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
          })((response) => {
            if (response?.status) {
              setUser(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingTimerCategory;
  const categoryLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerCategory);
      typingTimerCategory = setTimeout(() => {
        if (inputValue.length >= 1) {
          listCategoryDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            is_primary: true,
          })((response) => {
            if (response?.status) {
              setCatgory(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingTimerMaterial;

  const materialLoadOptionHandler = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerMaterial);
      typingTimerMaterial = setTimeout(() => {
        if (inputValue.length >= 1) {
          listMaterialDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
          })((response) => {
            if (response?.status) {
              setMaterial(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingTimerOriginal;
  const loadOriginalRoomOptions = (inputValue) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimerOriginal);

      typingTimerOriginal = setTimeout(() => {
        if (inputValue.length >= 1) {
          listRoomDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            sort_by: "room_number",
          })((response) => {
            resolve(response?.status ? response.data : []);
          });
        } else {
          setRoom(defaultRoom);
          resolve(defaultRoom);
        }
      }, 300);
    });
  };

  let typingTimerTransit;
  const loadTransitRoomOptions = (inputValue) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimerTransit);

      typingTimerTransit = setTimeout(() => {
        if (inputValue.length >= 1) {
          listRoomDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            sort_by: "room_number",
          })((response) => {
            resolve(response?.status ? response.data : []);
          });
        } else {
          setTransitRoom({
            data: transitRoom.default,
            isLoading: false,
          });
          resolve(transitRoom.default);
        }
      }, 300);
    });
  };

  const doneHandler = () => {
    setSelectedContents((prev) => {
      let updated = [...prev];

      // ADD the common filterValue FIRST (your existing behavior)
      if (filterValue) {
        if (!filterValue.value || filterValue.value.length === 0) {
          updated = updated.filter((item) => item.title !== filterValue.title);
        } else {
          const exists = updated.some((it) => it.title === filterValue.title);
          updated = exists
            ? updated.map((it) =>
                it.title === filterValue.title ? filterValue : it
              )
            : [...updated, filterValue];
        }
      }

      // THEN insert the 2 special filters (Original + Transit)
      const specialFilters = [originalFilter, transitFilter];

      specialFilters.forEach((f) => {
        if (!f) return;

        if (!f.value || f.value.length === 0) {
          updated = updated.filter((it) => it.title !== f.title);
        } else {
          const exists = updated.some((it) => it.title === f.title);
          updated = exists
            ? updated.map((it) => (it.title === f.title ? f : it))
            : [...updated, f];
        }
      });

      return updated;
    });

    formik.handleSubmit();
    setUpdate((u) => !u);
    setShowFilterBox(false);
  };

  useEffect(() => {
    setMaterialLoading(true);
    listMaterialDropdown({
      page: 1,
      limit: 10,
      museum_id: userData?.museum,
      sort_by: "material_name",
    })((response) => {
      if (response?.status) {
        setMaterial(response?.data);
        setDefaultMaterial(response?.data);
        setMaterialLoading(false);
      } else {
        setMaterialLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    setCategoryLoading(true);
    listCategoryDropdown({
      page: 1,
      limit: 10,
      sort_by: "category_name",
      museum_id: userData?.museum,
      is_primary: true,
    })((response) => {
      if (response?.status) {
        setCatgory(response?.data.sort());
        setDefaultCategory(response?.data);
        setCategoryLoading(false);
      } else {
        setCategoryLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    if (formik?.values?.primary_category?.length > 0) {
      setSubCategoryLoading(true);
      listSubCategoryDropdown({
        page: 1,
        limit: 10,
        sort_by: "category_name",
        museum_id: userData?.museum,
        is_primary: false,
        primary_category: formik?.values?.primary_category,
      })((response) => {
        if (response?.status) {
          setSubcategory(response?.data.sort());
          setdefaulSubtCateory(response?.data);
          setSubCategoryLoading(false);
        } else {
          setSubCategoryLoading(false);
        }
      });
    }
  }, [formik?.values?.primary_category]);

  useEffect(() => {
    setUserLoading(true);
    listUserDropdown({ museum_id: userData?.museum })((response) => {
      if (response?.status) {
        setUser(response?.data);
        setDefaultUser(response?.data);
        setUserLoading(false);
      } else {
        setUserLoading(false);
      }
    });
  }, []);
  useEffect(() => {
    setRoomLoading(true);
    listRoomDropdown({
      page: 1,
      museum_id: userData?.museum,
      sort_by: "room_number",
    })((response) => {
      if (response?.status) {
        setRoom(response?.data);
        setDefaultRoom(response?.data);
        setTransitRoom({
          data: response?.data,
          default: response?.data,
        });
        setRoomLoading(false);
      } else {
        setRoomLoading(false);
      }
    });
  }, []);

  const customComponentsCategory = {
    Option: (props) => (
      <div
        {...props.innerRef}
        {...props.innerProps}
        style={{
          backgroundColor: props.isFocused ? "#eee" : "transparent",
          padding: 10,
          cursor: "pointer",
        }}
      >
        {props.data.label}
        {props?.data?.key_category && (
          <img
            src={start}
            style={{
              paddingLeft: "20px",
              height: "18px",
              width: "36px",
              paddingBottom: "5px",
            }}
            alt="star"
          />
        )}
      </div>
    ),
  };

  useEffect(() => {
    if (menuIsOpen?.subCategory && subCategoryRef.current) {
      subCategoryRef.current.focus();
    }
  }, [menuIsOpen?.subCategory]);

  useEffect(() => {
    if (!initialFormikSnapshot) {
      setInitialFormikSnapshot(formik.values);
    }
  }, [formik.values, initialFormikSnapshot]);

  const LoadingDropdownMessage = (props) => (
    <div style={{ padding: "10px", textAlign: "center", color: "#666" }}>
      Loading categories...
    </div>
  );

  useEffect(() => {
    // When drawer opens

    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      // Ensure scroll is restored when component unmounts
      document.body.style.overflow = "auto";
    };
    // When drawer closes / unmounts
  }, [isOpen]);

  useEffect(() => {
    if (isClearAll) {
      setInitialFormikSnapshot(formik.values);
      setIsClearAll(false);
    }
  }, [isClearAll]);
  return (
    <div className="filter-content-box">
      <Form>
        <div className="filter-content-header">
          <GoArrowLeft
            onClick={() => {
              onBackToFilter(filterValue, initialFormikSnapshot);
            }}
          />
          <h4>{contentHeader}</h4>
        </div>
        <div className="filter-content-container">
          {showFilterBoxContent?.photostatus && (
            <div className="filter-contents">
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.photography_status === "to_do"}
                  onChange={(e) => photoStatusChangeHandler(e, "To do")}
                />
                <Form.Label>To do</Form.Label>
              </Form.Group>

              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={
                    formik?.values?.photography_status === "in_photography"
                  }
                  onChange={(e) =>
                    photoStatusChangeHandler(e, "In photography")
                  }
                />
                <Form.Label>In photography</Form.Label>
              </Form.Group>
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={
                    formik?.values?.photography_status ===
                    "photography_complete"
                  }
                  onChange={(e) =>
                    photoStatusChangeHandler(e, "Photography complete")
                  }
                />
                <Form.Label>Photography complete</Form.Label>
              </Form.Group>
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.photography_status === "re_shoot"}
                  onChange={(e) => photoStatusChangeHandler(e, "Reshoot")}
                />
                <Form.Label>Reshoot</Form.Label>
              </Form.Group>
            </div>
          )}
          {/* {showFilterBoxContent?.driveUrl &&
                <div className='filter-contents'>
                    <Form.Group style={{ display: "flex", gap: "15px" }}>
                        <Form.Check
                            checked={formik?.values?.hasDrive}
                            onChange={(e) => onDriveTrueHandler(e, "Has drive url")}
                        />
                        <Form.Label>Has drive url</Form.Label>

                    </Form.Group>

                    <Form.Group style={{ display: "flex", gap: "15px" }}>
                        <Form.Check
                            checked={formik?.values?.hasNoDrive}
                            onChange={(e) => onDriveFalseHandler(e, "Has drive url")}
                        />
                        <Form.Label>No drive url</Form.Label>

                    </Form.Group>

                </div>
            } */}

          {showFilterBoxContent?.condition && (
            <div className="filter-contents">
              {" "}
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                {" "}
                <Form.Check
                  checked={formik?.values?.conservation_grade?.includes("1")}
                  onChange={(e) => conditionGradeChangeHandler(e, "1")}
                />{" "}
                <Form.Label>1</Form.Label>{" "}
              </Form.Group>{" "}
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                {" "}
                <Form.Check
                  checked={formik?.values?.conservation_grade?.includes("2")}
                  onChange={(e) => conditionGradeChangeHandler(e, "2")}
                />{" "}
                <Form.Label>2</Form.Label>{" "}
              </Form.Group>{" "}
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                {" "}
                <Form.Check
                  checked={formik?.values?.conservation_grade?.includes("3")}
                  onChange={(e) => conditionGradeChangeHandler(e, "3")}
                />{" "}
                <Form.Label>3</Form.Label>{" "}
              </Form.Group>{" "}
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                {" "}
                <Form.Check
                  checked={formik?.values?.is_emergency === true}
                  onChange={(e) => conditionGradeChangeHandler(e, "Emergency")}
                />{" "}
                <Form.Label>Emergency</Form.Label>{" "}
              </Form.Group>{" "}
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                {" "}
                <Form.Check
                  checked={formik?.values?.conservation_grade?.includes(
                    "blank"
                  )}
                  onChange={(e) => conditionGradeChangeHandler(e, "blank")}
                />{" "}
                <Form.Label>No condition grading</Form.Label>{" "}
              </Form.Group>{" "}
            </div>
          )}
          {showFilterBoxContent?.iconic && (
            <div className="filter-contents">
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.hasIconic}
                  onChange={(e) => onIconicTrueHandler(e, "Has attachment")}
                />
                <Form.Label>Iconic</Form.Label>
              </Form.Group>

              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.hasNoIconic}
                  onChange={(e) => onIconicFalseHandler(e, "Has attachment")}
                />
                <Form.Label>Non iconic</Form.Label>
              </Form.Group>
            </div>
          )}
          {showFilterBoxContent?.remark && (
            <div className="filter-contents">
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.hasRemark}
                  onChange={(e) => onRemarkTrueHandler(e, "Has attachment")}
                />
                <Form.Label>Has remark</Form.Label>
              </Form.Group>

              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.hasNoRemark}
                  onChange={(e) => onRemarkFalseHandler(e, "Has attachment")}
                />
                <Form.Label>No remark</Form.Label>
              </Form.Group>
            </div>
          )}
          {showFilterBoxContent?.Referenceimage && (
            <div className="filter-contents">
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.hasImage}
                  onChange={(e) => onRefernceTrueHandler(e, "Has attachment")}
                />
                <Form.Label>Has attachment</Form.Label>
              </Form.Group>

              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.hasNoImage}
                  onChange={(e) => onRefernceFalseHandler(e, "Has attachment")}
                />
                <Form.Label>No attachment</Form.Label>
              </Form.Group>
            </div>
          )}
          {showFilterBoxContent?.driveUrl && (
            <div className="filter-contents">
              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.hasDrive}
                  onChange={(e) => onDriveTrueHandler(e, "Has drive url")}
                />
                <Form.Label>Has drive url</Form.Label>
              </Form.Group>

              <Form.Group style={{ display: "flex", gap: "15px" }}>
                <Form.Check
                  checked={formik?.values?.hasNoDrive}
                  onChange={(e) => onDriveFalseHandler(e, "Has drive url")}
                />
                <Form.Label>No drive url</Form.Label>
              </Form.Group>
            </div>
          )}

          {showFilterBoxContent?.room && (
            <div className="filter-contents">
              <AsyncSelect
                isMulti
                value={
                  formik.values.selectedRoom?.length > 0
                    ? formik.values.selectedRoom.map((label, index) => ({
                        value: formik.values.room[index],
                        label,
                      }))
                    : null
                }
                onChange={roomChangeHandler}
                defaultOptions={room}
                noOptionsMessage={() =>
                  roomLoading ? "Loading..." : "No options"
                }
                placeholder="Original location"
                loadOptions={loadOriginalRoomOptions}
                cacheOptions={false} // Ensures fresh results every search
                onInputChange={(newValue, { action }) => {
                  if (action === "input-change" && newValue === "") {
                    setRoom(defaultRoom); // Reset to default options
                  }
                }}
              />
            </div>
          )}
          {showFilterBoxContent?.room && (
            <div className="filter-contents">
              <AsyncSelect
                isMulti
                value={
                  formik.values.selectedTransitRoom?.length > 0
                    ? formik.values.selectedTransitRoom.map((label, index) => ({
                        value: formik.values.transit_room[index],
                        label,
                      }))
                    : null
                }
                onChange={transiRoomChangeHandler}
                defaultOptions={transitRoom?.data}
                noOptionsMessage={() =>
                  roomLoading ? "Loading..." : "No options"
                }
                placeholder="Transit location"
                loadOptions={loadTransitRoomOptions}
                cacheOptions={false} // Ensures fresh results every search
                onInputChange={(newValue, { action }) => {
                  if (action === "input-change" && newValue === "") {
                    setTransitRoom({
                      data: defaultRoom,
                      isLoading: false,
                    }); // Reset to default options
                  }
                }}
              />
            </div>
          )}

          {showFilterBoxContent?.category && (
            <>
              <div className="filter-contents">
                <AsyncSelect
                  menuIsOpen={menuIsOpen?.category}
                  onFocus={() =>
                    setMenuIsOpen({
                      category: true,
                    })
                  }
                  onBlur={() =>
                    setMenuIsOpen({
                      category: false,
                    })
                  }
                  isMulti
                  autoFocus
                  placeholder="Select primary category"
                  loadOptions={categoryLoadOptionHandler}
                  onChange={categoryChangeHandler}
                  components={{
                    ...customComponentsCategory,
                    LoadingMessage: LoadingDropdownMessage,
                  }}
                  defaultOptions={category}
                  value={formik?.values?.selectedCategory}
                  // value={objectformik?.values?.selectedCategory}
                  onInputChange={(newValue, { action }) => {
                    if (action === "input-change" && newValue === "") {
                      setCatgory(defaultcategory); // Reset to default options
                    }
                  }}
                  noOptionsMessage={() =>
                    categorLoading ? "Loading..." : "No options"
                  } // isLoading={categorLoading}
                />
              </div>
              <div className="filter-contents">
                <AsyncSelect
                  ref={subCategoryRef}
                  menuIsOpen={menuIsOpen?.subCategory}
                  onFocus={() =>
                    setMenuIsOpen({
                      subCategory: true,
                    })
                  }
                  onBlur={() =>
                    setMenuIsOpen({
                      subCategory: false,
                    })
                  }
                  isMulti
                  value={
                    formik?.values?.selctedSubCategory?.length > 0
                      ? formik?.values?.selctedSubCategory?.map((li) => ({
                          value: li?.value,
                          label: li?.label,
                        }))
                      : null
                  }
                  loadOptions={(inputValue) =>
                    subcategoryLoadOptionHandler(
                      inputValue,
                      formik,
                      setSubcategory,
                      false
                    )
                  }
                  defaultOptions={subCategory}
                  components={customComponentsCategory}
                  name="category"
                  type="text"
                  placeholder="Select subcategory"
                  onChange={subCategoryChangeHandler}
                  onInputChange={(newValue, { action }) => {
                    if (action === "input-change" && newValue === "") {
                      setSubcategory(defaultSubcategory); // Reset to default options
                    }
                  }}
                  noOptionsMessage={() =>
                    subCategoryLoading ? "Loading..." : "No options"
                  }
                />
              </div>
            </>
          )}
          {showFilterBoxContent?.material && (
            <div className="filter-contents">
              <AsyncSelect
                isMulti
                menuIsOpen={menuIsOpen?.material}
                onFocus={() =>
                  setMenuIsOpen({
                    material: true,
                  })
                }
                onBlur={() =>
                  setMenuIsOpen({
                    material: false,
                  })
                }
                autoFocus
                placeholder="Select material"
                loadOptions={materialLoadOptionHandler}
                onChange={materialChangeHandler}
                defaultOptions={material}
                noOptionsMessage={() =>
                  materialLoading ? "Loading..." : "No options"
                }
                value={
                  formik?.values?.selectedMaterial
                    ? formik?.values?.selectedMaterial?.map((li) => ({
                        value: li?.value,
                        label: li?.label,
                      }))
                    : null
                }
                components={customComponentsCategory}
                name="category"
                type="text"
                onInputChange={(newValue, { action }) => {
                  if (action === "input-change" && newValue === "") {
                    setMaterial(defaultMaterial); // Reset to default options
                  }
                }}
              />
            </div>
          )}
          {showFilterBoxContent?.Tags && (
            <div className="filter-contents">
              <Form.Control
                placeholder="Tags"
                onChange={tagChangeHandler}
                value={formik?.values?.tags}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // prevent form submit
                    doneHandler();
                  }
                }}
              />
            </div>
          )}
          {showFilterBoxContent?.Createdby && (
            <div className="filter-contents">
              <AsyncSelect
                isMulti
                menuIsOpen={menuIsOpen?.user}
                onFocus={() =>
                  setMenuIsOpen({
                    user: true,
                  })
                }
                onBlur={() =>
                  setMenuIsOpen({
                    user: false,
                  })
                }
                placeholder="Select user"
                loadOptions={userLoadOptionHandler}
                onChange={userChangeHandler}
                defaultOptions={user}
                autoFocus
                noOptionsMessage={() =>
                  userLoading ? "Loading..." : "No options"
                }
                value={
                  formik.values.selectedUser?.length > 0
                    ? formik.values.selectedUser.map((label, index) => ({
                        value: formik.values.created_by[index],
                        label,
                      }))
                    : null
                }
                // value={objectformik?.values?.selectedMaterial}
                // className='object_select'
                onInputChange={(newValue, { action }) => {
                  if (action === "input-change" && newValue === "") {
                    setUser(defaultUser); // Reset to default options
                  }
                }}
              />
            </div>
          )}
          {showFilterBoxContent?.Height && (
            <div className="filter-contents">
              <div style={{ display: "flex", gap: "15px" }}>
                <InputNumber
                  value={formik?.values?.height_min}
                  onChange={(e) => handleMinChange(e, "height")}
                  style={{ padding: "13px 11px" }}
                  placeholder="Min"
                />

                <InputNumber
                  value={formik?.values?.height_max}
                  onChange={(e) => handleMaxChange(e, "height")}
                  style={{ padding: "13px 11px" }}
                  placeholder="Max"
                />
              </div>
            </div>
          )}

          {showFilterBoxContent?.width && (
            <div className="filter-contents">
              <div style={{ display: "flex", gap: "15px" }}>
                <InputNumber
                  value={formik?.values?.width_min}
                  onChange={(e) => handleMinChange(e, "width")}
                  style={{ padding: "13px 11px" }}
                  placeholder="Min"
                />

                <InputNumber
                  value={formik?.values?.width_max}
                  onChange={(e) => handleMaxChange(e, "width")}
                  style={{ padding: "13px 11px" }}
                  placeholder="Max"
                />
              </div>
            </div>
          )}

          {showFilterBoxContent?.Depth && (
            <div className="filter-contents">
              <div style={{ display: "flex", gap: "15px" }}>
                <InputNumber
                  value={formik?.values?.depth_min}
                  onChange={(e) => handleMinChange(e, "depth")}
                  style={{ padding: "13px 11px" }}
                  placeholder="Min"
                />

                <InputNumber
                  value={formik?.values?.depth_max}
                  onChange={(e) => handleMaxChange(e, "depth")}
                  style={{ padding: "13px 11px" }}
                  placeholder="Max"
                />
              </div>
            </div>
          )}

          {showFilterBoxContent?.Daetable && (
            <div
              className="filter-contents datable-contents"
              style={{ paddingRight: "14px" }}
            >
              <div
                style={{ display: "flex", gap: "15px", alignItems: "center" }}
              >
                {/* <InputNumber
                            min={1000}
                            max={9999}
                            parser={(value) => value.replace(/\D/g, '').slice(0, 4)} // only digits, max 4
                            value={formik?.values?.period_start}
                            onChange={periodStarthandler}
                            style={{ padding: "13px 11px", width: "112px" }}
                            placeholder='Start date' /> */}
                <Select
                  value={formik?.values?.selectedPeriod}
                  onChange={periodChangeHandler}
                  placeholder="Select"
                  className="dateble-select"
                  options={[
                    { value: "CE", label: "CE" },
                    { value: "BCE", label: "BCE" },
                  ]}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      border: "1px solid #EEEEEE",
                      boxShadow: "none",
                    }),
                  }}
                />
                <Form.Control
                  value={formik?.values?.period_start}
                  onChange={periodStarthandler}
                  style={{
                    padding: "13px 11px",
                    width: "93px",
                    height: "39px",
                  }}
                  placeholder="Start date"
                />
                {/* <InputNumber
                            onChange={periodEndthandler}
                            value={formik?.values?.period_end}
                            style={{ padding: "13px 11px", width: "68px" }}
                            placeholder='End date' /> */}
                <Form.Control
                  onChange={periodEndthandler}
                  value={formik?.values?.period_end}
                  style={{
                    padding: "13px 11px",
                    width: "85px",
                    height: "39px",
                  }}
                  placeholder="End date"
                />
              </div>
            </div>
          )}

          {showFilterBoxContent?.createdDate && (
            <div className="filter-contents">
              <div style={{ display: "flex", gap: "15px" }}>
                <RangePicker
                  disabledDate={(current) => {
                    // Convert current to a Day.js instance before checking
                    return current && dayjs(current).isAfter(dayjs(), "day");
                  }}
                  value={
                    formik?.values?.selectedDate
                      ? formik?.values?.selectedDate.map((d) =>
                          dayjs.isDayjs(d) ? d : dayjs(d)
                        )
                      : null
                  }
                  format="DD-MM-YYYY"
                  onChange={Handledatefilter}
                />
              </div>
            </div>
          )}
          {showFilterBoxContent?.updatedAt && (
            <div className="filter-contents">
              <div style={{ display: "flex", gap: "15px" }}>
                <RangePicker
                  disabledDate={(current) => {
                    // Convert current to a Day.js instance before checking
                    return current && dayjs(current).isAfter(dayjs(), "day");
                  }}
                  value={
                    formik?.values?.selectedUpdateDate
                      ? formik?.values?.selectedUpdateDate.map((d) =>
                          dayjs.isDayjs(d) ? d : dayjs(d)
                        )
                      : null
                  }
                  format="DD-MM-YYYY"
                  onChange={HandledateUpdatefilter}
                />
              </div>
            </div>
          )}
          {showFilterBoxContent?.Acquistionmethod && (
            <div className="filter-contents">
              <div>
                <Select
                  isMulti
                  menuIsOpen={menuIsOpen?.acquistion}
                  onFocus={() =>
                    setMenuIsOpen({
                      acquistion: true,
                    })
                  }
                  onBlur={() =>
                    setMenuIsOpen({
                      acquistion: false,
                    })
                  }
                  placeholder="Acquisition method"
                  onChange={accquistionChangeHandler}
                  value={
                    formik.values.acquisition_method?.length > 0
                      ? formik.values.acquisition_method.map((label) => ({
                          label,
                          value: label, // assuming value is same as label
                        }))
                      : null
                  }
                  options={[
                    { value: "Donation", label: "Donation" },
                    { value: "Borrowed", label: "Borrowed" },
                    { value: "Loan", label: "Loan" },
                  ]}
                />
              </div>
            </div>
          )}
        </div>
        <div className="submit-btn-row global-search-content-button">
          <Button className="submit-btn" type="button" onClick={doneHandler}>
            {/* {buttonloader && submitLoader ? <SimpleBackdrop /> : "Filter"} */}
            Done
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default GlobalsearchContent;
